import { surveyAxiosClient } from '@kinderlabs-pos/apis/axios';

export type ElectronicReceiptConfigType = {
  isMobileReceiptAvailable: boolean;
};

export const getElectronicReceiptConfigAsync =
  (rootUrl: string) =>
  async ({ storeId }: { storeId: number }) =>
    (
      await surveyAxiosClient.get<ElectronicReceiptConfigType>(
        `${rootUrl}/api/v2/surveyInfos/mobile-receipt-status`,
        { params: { storeId } }
      )
    ).data;
